import { Container} from "react-bootstrap";

export default function NotFound() {
  return (
    <Container className="notFoundCenterPositioned">
      <h1>Oops! You seem to be lost.</h1>
      <p>The page does not exist!</p>
    </Container>
  );
}
